import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

import AccountUnavailable from "../../components/accountUnavailable";
import { OverlayPreloader } from "../../components/common/preloader";
import PrivateRoutes from "../privateRoutes";

const PrivateRoutesContainer = ({ isLoggedIn, keycloak }) => {
  const location = useLocation();
  const accountUnavailable = useSelector(state => state.main.accountUnavailable);

  if (isLoggedIn === null) {
    return <OverlayPreloader />;
  }

  if (isLoggedIn) {
    // The member is signed in with Keycloak, but the backend has no account for the identity (GROWTH-7362): every
    // request of the member area is refused, so none of it is mounted.
    if (accountUnavailable) {
      return <AccountUnavailable requestId={accountUnavailable.requestId} />;
    }

    return <PrivateRoutes keycloak={keycloak} />;
  }

  const returnTo = `${location.pathname}${location.search}`;
  const loginSearch = returnTo && returnTo !== "/" ? `?return=${encodeURIComponent(returnTo)}` : "";

  return <Navigate to={`/login${loginSearch}`} replace />;
};

export default PrivateRoutesContainer;
